export default "__VITE_ASSET__1Vdu1Qho__"